<template>
  <div class="block36">
    <!-- 返回 -->
    <div class="return">
      <router-link to="/">
        <span class="arrow"></span>返回首页
      </router-link>
    </div>
    <!-- 返回 -->
    <!-- 内容 -->
    <div class="container">
      <h2 class="title1">仪表、控件和其他功能</h2>
      <div class="container-content">
        <h3 class="title2">点火开关</h3>
        <p>
          在发动机停止的情况下，将点火开关保持在 <img class="icon_middle" src="../img/yunzhuan.png" /> （运转）位置会让蓄电池放电。<br>骑行时不要旋转钥匙。
        </p>
        <h3 class="title2">发动机停止开关</h3>
        <p>除非在紧急情况下，不要使用发动机停止开关。这样做时，会导致发动机突然关闭，使驾驶不安全。<br>如果您用发动机停止开关停止发动机，请把点火开关关掉。否则会导致蓄电池亏电。</p>
        <h3 class="title2">总里程表</h3>
        <p>读数超过999999后，显示会锁定在999999。</p>
        <h3 class="title2">单程表</h3>
        <p>当读数超过9999.9时，行程表A和B返回0。</p>
        <h3 class="title2">文档袋</h3>
        <p>可以将使用说明书、登记号和保险单存放在鞍座下方的塑料文档袋内。</p>
        <h3 class="title2">点火切断系统</h3>
        <p>
          如果摩托车翻倒，倾角（倾斜角）传感器会自动停止发动机和燃油泵的运转。若要重置传感器，您必须在可以重新启动发动机之前将点火开关转至
          <img class="icon_middle" src="../img/zhinankaiguan.png" />（关闭）位置，然后再转回至
          <img class="icon_middle" src="../img/yunzhuan.png" />（运转）位置。
        </p>
      </div>
      <div class="foot-btn">
        <div class="prev">
          <router-link to="/block35">上一页</router-link>
        </div>
        <div class="next">
          <router-link to="/block37">下一页</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>